import React, { useRef, useState, useEffect } from "react"
import { OldButton } from "@kit/design/old-button"
import { useTrailingDebounce as useDebounce } from "hooks/use-trailing-debounce"
import isValidUrl, { tryAddProtocol } from "../../utils/is-valid-url"

// eslint-disable-next-line no-unused-vars
const ToolbarMenu = ({ editor, close, ...props }) => {
  const input = useRef()
  const [href, setHref] = useState(editor.getHref())
  const [urlError, setUrlError] = useState(false)

  useEffect(() => {
    input.current.focus()
  }, [])

  // Add debounced URL validation like in external-links
  const [validateUrl] = useDebounce(({ url }) => {
    setUrlError(!isValidUrl(tryAddProtocol(url), { strict: true }))
  }, 200)

  const handleChange = event => {
    const url = event.target.value
    setHref(url)
    validateUrl({ url })
  }

  const handleSubmit = event => {
    event.preventDefault()
    if (urlError) return

    if (!href) {
      if (editor.isLink()) {
        editor.unwrapLink()
      }
    } else {
      const modifiedHref = tryAddProtocol(href)
      editor.insertLink({ href: modifiedHref })
    }

    close()
  }

  return (
    <div className="p-2">
      <form onSubmit={handleSubmit}>
        <input
          aria-label="URL"
          className={`mb-2 rounded-sm text-white block focus:outline-blue py-1 px-2 ${
            urlError ? "border border-red-500" : ""
          }`}
          style={{
            background: "#36404a",
            width: "220px"
          }}
          placeholder="URL"
          ref={input}
          name="href"
          onChange={handleChange}
          value={href}
        />
        {urlError && (
          <div className="text-red-500 text-sm mb-2">
            Please enter a valid URL
          </div>
        )}

        <OldButton
          className="w-full"
          is="primary"
          type="submit"
          disabled={urlError || !href}
        >
          Add Link
        </OldButton>
      </form>
    </div>
  )
}

export default ToolbarMenu
